const state = {
  loginAccount: null,
  loginUsername: null,
  loginStatus: false,
  loginAccessList: null,
  selectPage: "",
  selectPageName: "",
  pageName: null,
  PageAccess: {
    home: false,
    elecboard: false,
    machstatus: false,
    yieldstatistics: false,
    activation: false,
    operatelog: false,
    errorhistory: false,
    workorderhistory: false,
    ordermanagement: false,
    machmalfunction: false,
    operation: false,
    heattreatmentinstant: false,
    statisticstable: false,
    wireinquire: false,
    pcreport:false
  }
};
const getters = {
  get_loginData: state => {
    var loginData = {};
    loginData.account = state.loginAccount;
    loginData.username = state.loginUsername;
    loginData.status = state.loginStatus;
    loginData.accessList = state.loginAccessList;
    return loginData;
  },
  get_selectPage: state => {
    var selectPage = state.selectPage;
    return selectPage;
  },
  get_selectPageName: state => {
    var selectPageName = state.selectPageName;
    return selectPageName;
  },
  get_pageName: state => {
    var pageName = state.pageName;
    return pageName;
  },
  get_pageAccess: state => {
    var pageAccess = {};
    pageAccess.home = state.PageAccess.home;
    pageAccess.elecboard = state.PageAccess.elecboard;
    pageAccess.machstatus = state.PageAccess.machstatus;
    pageAccess.yieldstatistics = state.PageAccess.yieldstatistics;
    pageAccess.activation = state.PageAccess.activation;
    pageAccess.operatelog = state.PageAccess.operatelog;
    pageAccess.errorhistory = state.PageAccess.errorhistory;
    pageAccess.workorderhistory = state.PageAccess.workorderhistory;
    pageAccess.ordermanagement = state.PageAccess.ordermanagement;
    pageAccess.machmalfunction = state.PageAccess.machmalfunction;
    pageAccess.operation = state.PageAccess.operation;
    pageAccess.heattreatmentinstant = state.PageAccess.heattreatmentinstant;
    pageAccess.statisticstable = state.PageAccess.statisticstable;
    pageAccess.wireinquire = state.PageAccess.wireinquire;
    pageAccess.pcreport = state.PageAccess.pcreport;
    return pageAccess;
  }
};
const actions = {
  change_loginData(context, obj) {
    context.commit("CHANGE_LOGINDATA", obj);
  },
  change_selectPage(context, obj) {
    context.commit("CHANGE_SELECTPAGE", obj);
  },
  change_selectPageName(context, obj) {
    context.commit("CHANGE_SELECTPAGENAME", obj);
  },
  set_pageName(context) {
    context.commit("SET_PAGENAME");
  },
  change_pageAccess(context, obj) {
    context.commit("CHANGE_PAGEACCESS", obj);
  },
};
const mutations = {
  CHANGE_LOGINDATA(state, obj) {
    state.loginAccount = obj.account;
    state.loginStatus = obj.status;
    state.loginUsername = obj.username;
    state.loginAccessList = obj.accessList;
  },
  CHANGE_SELECTPAGE(state, value) {
    state.selectPage = value;
  },
  CHANGE_SELECTPAGENAME(state, value) {
    state.selectPageName = value;
  },
  SET_PAGENAME(state) {
    state.pageName = {
      home: "總覽",
      elecboard: "電子看板",
      machstatus: "機台狀態",
      yieldstatistics: "產量統計",
      activation: "稼動率",
      operatelog: "運轉日誌",
      errorhistory: "異常統計",
      workorderhistory: "工單履歷",
      ordermanagement: "工單管理",
      machmalfunction: "機台故障",
      operation: "營運模組",
      heattreatmentinstant: "即時參數顯示",
      statisticstable: "統計報表",
      wireinquire: "線材查詢",
      pcreport:"生管報表"
    };
  },
  CHANGE_PAGEACCESS(state, obj) {
    state.PageAccess.home = obj.home;
    state.PageAccess.elecboard = obj.elecboard;
    state.PageAccess.machstatus = obj.machstatus;
    state.PageAccess.yieldstatistics = obj.yieldstatistics;
    state.PageAccess.activation = obj.activation;
    state.PageAccess.errorhistory = obj.errorhistory;
    state.PageAccess.operatelog = obj.operatelog;
    state.PageAccess.workorderhistory = obj.workorderhistory;
    state.PageAccess.ordermanagement = obj.ordermanagement;
    state.PageAccess.machmalfunction = obj.machmalfunction;
    state.PageAccess.operation = obj.operation;
    state.PageAccess.heattreatmentinstant = obj.heattreatmentinstant;
    state.PageAccess.statisticstable = obj.statisticstable;
    state.PageAccess.wireinquire = obj.wireinquire;
    state.PageAccess.pcreport = obj.pcreport;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/getLogin.js